import React from 'react';
import styled from 'styled-components';

import { Text, ColContainer, RowContainer } from '../atoms';
import OpeningDate from '../atoms/OpeningDate';

const SectionHeaderContainer = styled(ColContainer)`
  padding: 48px 24px 32px;

  @media (max-width: 799px) {
    width: 100%;
    align-items: flex-start;
  }
`;

const DescText = styled(Text)`
  font-size: 16px;
  line-height: 24px;
  word-break: keep-all;
  white-space: pre-line;
  font-weight: 400;
  color: white;

  max-width: 500px;
  text-align: center;

  @media (max-width: 799px) {
    max-width: none;
    text-align: left;
  }
`;

type SectionHeaderProps = {
  icon: string;
  name: string;
  title: string[];
  desc: string;
  date: string | null;
  color: string;
};

function SectionHeader({
  icon,
  name,
  title,
  desc,
  date,
  color,
}: SectionHeaderProps) {
  return (
    <SectionHeaderContainer>
      <Text size='20px' weight='800' mb='8px' color='white'>
        {`${icon} ${name}`}
      </Text>
      <Text size='40px' weight='800' color='white'>
        {title[0]}
      </Text>
      <RowContainer style={{ marginBottom: '4px', overflow: 'hidden', display: 'inline', wordBreak: 'keep-all' }}>
        <Text size='40px' weight='800' color={color} style={{ display: 'inline' }}>
          {title[1]}
        </Text>
        <Text size='40px' weight='800' color='white' style={{ display: 'inline' }}>
          {title[2]}
        </Text>
      </RowContainer>
      <DescText>{desc}</DescText>
      { date && (
        <RowContainer style={{ padding: '20px 0px 16px' }}>
          <OpeningDate date={date} color={color}/>
        </RowContainer>
      )}
    </SectionHeaderContainer>
  );
}

export default SectionHeader;
